import { render, staticRenderFns } from "./CamadasAccordion.vue?vue&type=template&id=11744315&scoped=true&lang=pug"
import script from "./CamadasAccordion.vue?vue&type=script&lang=js"
export * from "./CamadasAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11744315",
  null
  
)

export default component.exports